<script>
import api from 'api/quick-share';

export default {
  name: 'PendingShares',
  data() {
    return {
      collapsed: this.open !== 'true'
    };
  },
  mounted() {
    setTimeout(this.check, 2000);
  },

  methods: {
    check() {
      api.hasPending().then(data => {
        if (data.has_shares && data.shares_count) {
          Swal.fire({
            title: 'Hooray !!!',
            html:
              '<span class="is-size-4">Someone has <strong>shared</strong> course with you! <br/> Do you want to receive it?</span>',
            type: 'success',
            showCancelButton: false,
            confirmButtonText: 'Yes I Do!'
          }).then(result => {
            if (result.value) {
              api.receivePending().then(() => {
                Swal.fire(
                  'Success!',
                  'You received shared courses. We will redirect you to your courses.',
                  'success',
                );

                setTimeout(() => {
                  location.href = '/my-courses';
                }, 3000);
              });
            }
          });
        }
      });
    }
  },

  render(h) {
    return h();
  }
};
</script>
